import { O, RR, s } from '@packages/prelude'
import { fromTraversable, Lens, Prism } from 'monocle-ts'
import { indexReadonlyRecord } from 'monocle-ts/Index/ReadonlyRecord'

export interface UserImageData {
  image: O.Option<File>
  previewUrl: O.Option<string>
  remoteUrl: O.Option<string>
  id: number
  title: string
  description: O.Option<string>
  optional: boolean
  fieldId: string
}

export const userImageDataById = (id: string) => indexReadonlyRecord<UserImageData>().index(id)

export const imageLens = Lens.fromProp<UserImageData>()('image')
export const remoteUrlLens = Lens.fromProp<UserImageData>()('remoteUrl')

export const userImageImageLens = (id: string) => userImageDataById(id).composeLens(imageLens)

export const userImagePreviewUrlLens = (id: string) =>
  userImageDataById(id).composeLens(Lens.fromProp<UserImageData>()('previewUrl'))

export const userImageRemoteUrlLens = (id: string) => userImageDataById(id).composeLens(remoteUrlLens)

const UserImageDataTraversable = fromTraversable(RR.getTraversable(s.Ord))<UserImageData>()

export const getAllUserImageUrls = UserImageDataTraversable.composeLens(Lens.fromProp<UserImageData>()('previewUrl'))
  .composePrism(Prism.some())
  .asFold().getAll
